import { config } from '@services/config';
import { BrokerageDivisionSearchRequestQuery, BrokerageDivisionSearchResponse } from '@lio/api-types';
import { queryKeys } from '@services/brokerage-division/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

const getBrokerageDivisionsQuery = (params: BrokerageDivisionSearchRequestQuery) => {
  const { label, type, sort } = params;
  const query = new URLSearchParams();
  if (label) {
    query.append('label', label);
  }
  if (type) {
    query.append('type', String(type));
  }
  if (sort) {
    query.append('sort', sort.toString());
  }
  return query.toString();
};

export const useBrokerageDivisions = (params: BrokerageDivisionSearchRequestQuery & { enabled?: boolean }) => {
  const client = useClient();
  const query = getBrokerageDivisionsQuery(params);
  const result = useQuery({
    queryKey: queryKeys.brokerageDivisions,
    queryFn: async () => {
      const response = await client.get(`brokerage-division?${query}`).json<BrokerageDivisionSearchResponse>();
      return response.items;
    },
    enabled: params.enabled ?? true,
    ...config,
  });
  return { ...result, brokerageDivisions: result.data || [] };
};
